import { render } from "./LetterWrapper.vue?vue&type=template&id=d78983c6"
import script from "./LetterWrapper.vue?vue&type=script&lang=js"
export * from "./LetterWrapper.vue?vue&type=script&lang=js"

import "./LetterWrapper.vue?vue&type=style&index=0&id=d78983c6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__